// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3cqSl","actionsCol":"EnrolledClinics_actionsCol__1QcZ2"};